import { createContext, useState, useCallback, type ReactNode } from "react";

interface FindContextType {
  findQuery: string | undefined;
  setFindQuery: (query: string | undefined) => void;
  initializeFindQuery: (query: string) => void;
}

const FindContext = createContext<FindContextType | undefined>(undefined);

export { FindContext };

export function FindProvider({ children }: { children: ReactNode }) {
  const [findQuery, setFindQueryState] = useState<string | undefined>(
    undefined
  );

  const setFindQuery = useCallback((query: string | undefined) => {
    setFindQueryState(query);
  }, []);

  const initializeFindQuery = useCallback(
    (query: string | undefined) => {
      if (findQuery === undefined) {
        setFindQueryState(query || "");
      }
    },
    [findQuery]
  );

  const value = {
    findQuery,
    setFindQuery,
    initializeFindQuery,
  };

  return <FindContext.Provider value={value}>{children}</FindContext.Provider>;
}
